export const menu = [
  { key: 'home', children: [] },
  { key: 'productGroup', children: [{ key: 'highRateCell' }, { key: 'batteryModule' }] },
  { key: 'solutions', children: [{ key: 'heavyTransport' }, { key: 'logisticsFreight' }, { key: 'cityDelivery' },
    { key: 'lightPassengerVehicle' }, { key: 'highSpeedMotorcycle' }, { key: 'electricalTools' }, { key: 'drone' }] },
  { key: 'technology', children: [{ key: 'materialTechnology' }, { key: 'structuralTechnology' }, { key: 'cloudPlatform' }] },
  { key: 'about', children: [{ key: 'corporateCulture' }, { key: 'companyProfile' }, { key: 'productionOffice' }, { key: 'news' }] },
  { key: 'contactUs', children: [{ key: 'talentRecruitment' }, { key: 'channelCooperation' }, { key: 'bidAnnouncement' }] }
]
